// Polyfills
import 'nodelist-foreach-polyfill';
// Modules
import $ from 'jquery';
import Menu from './Menu';
import Drupal from './Drupal';
import Sticky from './Sticky';
import Header from './Header';
import Search from './Search';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import DDTemplates from './DDTemplates';
import SmartFooter from './SmartFooter';
import CalendarList from './CalendarList';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import Placeholder from './Placeholder';
import Hero from './Hero';
import Banner from './Banner';
import Viewable from './Viewable';
import EventSlider from './EventSlider';
import Spotlight from './Spotlight';
import Quote from './Quote';
import Selectable from './Selectable';
import Lightbox from './Lightbox';
import ExtLinks from './ExtLinks';
import Readmore from './Readmore';

const ESC_KEY = 27;

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helper class to signal the loading of behaviors.
  $(document.body, context).addClass('initialized');

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates(context);
  }

  // Hero Banner Homepage Section
  $('.hero.banner', context).each((i, element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Upcoming Events Homepage Section
  $('.events.block', context).each((i, element) => {
    if (!element.EventSlider) {
      element.EventSlider = new EventSlider(element);
    }
  });

  // Spotlight Homepage Section
  $('.spotlight.block', context).each((i, element) => {
    if (!element.Spotlight) {
      element.Spotlight = new Spotlight(element);
    }
  });

  // Quote Homepage Section
  $('.quote.block', context).each((i, element) => {
    if (!element.Quote) {
      element.Quote = new Quote(element);
    }
  });

  // Term Banner
  $('.term.banner', context).each((i, element) => {
    if (!element.Banner) {
      element.Banner = new Banner(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Locked header with headroom.js
  $('.page-header', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Control the search functionality
  $('.toolbar', context).each((i, element) => {
    if (!element.Search) {
      element.Search = new Search(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu) {
      element.Menu = new Menu(element);
    }
  });

  // Term Navigation functionality
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // External Links add rel="noreferrer"
  $('a[target="_blank"]', context).each((i, element) => {
    if (!element.ExtLinks) {
      element.ExtLinks = new ExtLinks(element);
    }
  });

  // Remove read-more-text from Front page
  $('.front .link-read-more', context).each((i, element) => {
    if (!element.Readmore) {
      element.Readmore = new Readmore(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Repurpose link as a button instead
  const $footerlinks = $('.footerlinks.block .node-header a', context);
  if ($footerlinks.length) {
    $footerlinks.addClass('menu-toggle')
      .removeAttr('href')
      .on('click', (event) => {
        $(event.currentTarget).closest('.node').toggleClass('expand');
      });
  }

  // Remove header link of signup footer post
  const $signupLinks = $('.signup.block .node-header a', context);
  if ($signupLinks.length) {
    $signupLinks.children().unwrap();
  }

  // Add placeholder text
  $('.signup .type-textfield, .signup .type-textarea', context).each((i, element) => {
    if (!element.Placeholder) {
      element.Placeholder = new Placeholder(element);
    }
  });

  // An array of blocks which should report when they're within the viewport/window.
  const viewableSelectors = [
    '.banner.block',
    '.quicklinks.block',
    '.front .page .block-title',
    '.events.block .views-row',
    '.events.block .view-footer',
    '.spotlight.block .node-header',
    '.spotlight.block .node-image',
    '.providers.block .node-upper-image',
    '.providers.block .node-content',
    '.providers.block .view-footer',
    '.quote.block',
  ];

  // Homepage Viewable Transitions
  $(viewableSelectors.join(','), context).each((i, element) => {
    if (!element.Viewable) {
      element.Viewable = new Viewable(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // List Style Calendar
  $('.calendars.list-calendar', context).each((i, element) => {
    if (!element.CalendarList) {
      element.CalendarList = new CalendarList(element);
    }
  });

  // Event Style Calendar
  // @desc Removes the prefix 'Function Area - ' from the option text label.
  $('.calendars.event-calendar', context).each((i, element) => {
    if (!element.prefixRemoved) {
      element.prefixRemoved = true;
      $('.form-select option', element).each((o, option) => {
        option.textContent = option.textContent.replace(/Function Area - /g, '');
      });
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Close flyout when close icon or overlay is clicked
  const $flyoutHotspots = $('button.close-icon, .overlay', context);
  if ($flyoutHotspots.length) {
    $flyoutHotspots.on('click', () => {
      $(document.body, context).removeClass('menu-active search-active');
    });
  }

  // Transition tabs to a select list if there are 5 or more.
  $('.dtabs', context).each((i, element) => {
    const total = $(element).find('.tab').length;
    if (!element.Selectable && total >= 5) {
      element.Selectable = new Selectable(element, i);
    }
  });

  // Close flyout when Escape key is pressed.
  $(window).keydown((event) => {
    if (event.which === ESC_KEY) {
      $(document.body).removeClass('menu-active search-active');
    }
  });

  // Add phone support to all mobile devices
  if (window.outerWidth <= 1024) {
    $('.node-contact .field-phone', context).each((i, element) => {
      if (!element.phoneSupport) {
        element.phoneSupport = true;
        const text = $(element).text();
        const phone = text.replace(/[() -]/g, '');
        $(element).html(`<a href="tel:${phone}">${text}</a>`);
      }
    });
  }

  // Modaal, the Lightbox Alternative
  if (!document.body.Lightbox) {
    document.body.Lightbox = new Lightbox(context);
  }

  // Remove (addthis.com) #at4-palogo <a> without actual link (Lighthouse score)
  window.addEventListener('load', () => {
    setTimeout(() => {
      const at4 = document.querySelector('#at4-palogo');
      if (at4) {
        at4.remove();
      }
    }, 10);
  });
});
